import { useMutation } from '../../../ReactQuery';
import { post } from '../../../redux/api';
import type {
  CreateServiceAccountRequest,
  CreateServiceAccountResponse,
} from '../../../../shared/types/routes/serviceAccounts';

/**
 * Creates a service account for the given organization.
 */
function createServiceAccount(data: CreateServiceAccountRequest) {
  return post<CreateServiceAccountRequest, CreateServiceAccountResponse>('/api/users/service-accounts', data);
}

/**
 * Hook to create a service account.
 */
export default function useCreateServiceAccount() {
  return useMutation({
    mutationFn: createServiceAccount,
  });
}
